import React from 'react';

const ChatBotConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/organizationalsetup/chatbottype',
			component:React.lazy(() => import('./ChatBot')) 
        }
	]
};

export default ChatBotConfig;